var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container mx-auto"},[_c('div',{staticClass:"mx-4 py-5"},[_c('doe-button',{attrs:{"prefix":"chevronLeft","size":"small","textAlignment":"left"},on:{"click":function($event){return _vm.handleBack()}}},[_vm._v("\n      "+_vm._s(_vm.label)+"\n    ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }